module.exports = __webpack_public_path__ + "static/media/servicekey.2874582c.jpg";